import { registerLicense } from '@syncfusion/ej2-base';
import { GanttPlugin } from '@syncfusion/ej2-vue-gantt';
import Vue from 'vue';

registerLicense('ORg4AjUWIQA/Gnt2V1hhQlJAfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5bdUVjUXpWcXNTQmNe');

Vue.use(GanttPlugin);
